interface CajaBadgeProps {
  caja?: string;
}

export function CajaBadge({ caja }: CajaBadgeProps) {
  if (!caja) return null;
  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-600 whitespace-nowrap">
      {caja}
    </span>
  );
}
